module.exports = __webpack_public_path__ + "img/d3af821dda0ad06824924d50d3445ced.bde948a7.png";